import {IErrors} from "@/model/IErrors";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/RootState";
import responseHandler from "@/plugins/errorHandling";
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IRealtimeData} from "@/model/Realtime/IRealtimeData";


interface RealtimeState {
  realtime: IRealtimeData;
  fullDays: IRealtimeData;
  // logs: ILockerLog[]; // we might need this later to show the logs
  errors: IErrors;
}

const state: RealtimeState = {
  realtime: {} as IRealtimeData,
  fullDays: {} as IRealtimeData,
  // logs: [],
  errors: {},
};

const getters: GetterTree<RealtimeState, RootState> = {
  realtime: (state: RealtimeState): IRealtimeData => state.realtime,
  fullDays: (state: RealtimeState): IRealtimeData => state.fullDays,
  errors: (state) => state.errors,
}

const actions: ActionTree<RealtimeState, RootState> = {

  fetchRealtime: ({ commit }, lockerId: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'real/time',
      method: "GET",
    }),
    commit,
    'realtimeLoaded'
  ),

  fetchFullDays: ({ commit }, lockerId: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'real/target',
      method: "GET",
    }),
    commit,
    'fullDaysLoaded'
  ),

  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },

  cleanErrors: ({commit}): any => {
    commit('errors', []);
  }

}

const mutations: MutationTree<RealtimeState> = {

  realtimeLoaded(state: RealtimeState, payload: IRealtimeData) {
    state.realtime = payload;
  },

  fullDaysLoaded(state: RealtimeState, payload: IRealtimeData) {
    state.fullDays = payload;
  },

  errors(state, payload: IErrors) {
    state.errors = payload;
  },

}

const namespaced: boolean = true;

export const realtimeModule: Module<RealtimeState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
